import styled from 'styled-components';

export const StyledPayAllElementHeader = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: 4px solid transparent;
    border-radius: 25px;
    justify-content: space-evenly;
    background-color: #fff;
    padding: 3px 0;
    gap: 12px;
    margin-top: 5px;

    > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(20% - 12px);
    }

    @media only screen and (max-width: 531px) {
        > div {
            > p {
                font-size: 16px;
            }
        }
    }
`;
